import { createSlice } from "@reduxjs/toolkit";
import { editCuisineAPI } from "../../api/cuisine";

const data = {
  isLoading: false,
  error: "",
  message: null,
  data: null,
}; 

const editCuisineSlice = createSlice({
  name: "editCuisine",
  initialState: data,
  reducers: {
   editCuisineSlice(state) {
      state.isLoading = true;
    },
   editCuisineSliceSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload;
    },
    editCuisineSliceFailure(state, action) {
      state.isLoading = false;
      state.data = action.payload;
    },
    editCuisineSliceReset(state) {
      state.isLoading = false;
      state.data = null;
    },
  },
});
export const editCuisineHandler = (id:any,data:any) => async (dispatch: any) => {
  try {
    dispatch(editCuisineAction.editCuisineSlice());
    const response: any = await editCuisineAPI(id,data);
    
    dispatch(editCuisineAction.editCuisineSliceSuccess(response));
  } catch (e: any) {
    dispatch(editCuisineAction.editCuisineSliceFailure(e?.response?.data));
  }
};
export default editCuisineSlice.reducer;
export const editCuisineAction = editCuisineSlice.actions;
